import { ArrowLeftIcon, BugIcon, ImageBrokenIcon } from "@phosphor-icons/react";
import { createRouter, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@workos-inc/authkit-react";

import Button from "@gx/dls/buttons/Button";

import ErrorLayout from "@/layouts/ErrorLayout";

import { useGetCurrentUserQuery } from "@/api/queries/users";

import { routeTree } from "./routeTree.gen";

const DEFAULT_PRELOAD = "intent";
const DEFAULT_PRELOAD_STALE_TIME = 300_000;

export interface RouterContext {
  workosAuth: ReturnType<typeof useAuth>;
  currentUser: ReturnType<typeof useGetCurrentUserQuery>["data"];
}

const DEFAULT_CONTEXT: RouterContext = {
  workosAuth: undefined!,
  currentUser: undefined,
};

const DefaultErrorComponent = ({ error }: { error: Error }) => {
  return (
    <ErrorLayout
      icon={BugIcon}
      header="Looks like there was a glitch in the matrix"
      message="Please try again later"
      error={error}
    />
  );
};

const DefaultNotFoundComponent = () => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    void navigate({ to: "/projects", search: {} });
  };

  return (
    <ErrorLayout
      icon={ImageBrokenIcon}
      header="Page not found"
      message="The page you are looking for does not exist"
      actions={
        <Button label="Go to dashboard" icon={ArrowLeftIcon} onClick={handleGoToDashboard} />
      }
    />
  );
};

export const router = createRouter({
  routeTree,
  context: DEFAULT_CONTEXT,
  defaultErrorComponent: DefaultErrorComponent,
  defaultNotFoundComponent: DefaultNotFoundComponent,
  defaultPreload: DEFAULT_PRELOAD,
  defaultPreloadStaleTime: DEFAULT_PRELOAD_STALE_TIME,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
